import { render, staticRenderFns } from "./CalculationEdit.vue?vue&type=template&id=dc232850&scoped=true&"
import script from "./CalculationEdit.vue?vue&type=script&lang=js&"
export * from "./CalculationEdit.vue?vue&type=script&lang=js&"
import style0 from "./CalculationEdit.vue?vue&type=style&index=0&id=dc232850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc232850",
  null
  
)

export default component.exports